import { ComparativeDisplayType, RollingType } from './GlobalKpiOption'
import { ShowPerEnum } from './GlobalMetric'

export type VariantOption = {
  active_show_per: ShowPerEnum | null
  comparative_display_type: {
    selected: ComparativeDisplayType
    options: ComparativeDisplayType[]
  }
  id: string
  index: number
  is_percentage: boolean
  number_of_decimals: number
  rolling_active: RollingType | null
  show_per_unit: string | null
  title: string
  variant_kpi_template_id: string
  widget_id: string
}

// what the table's segments show: the values of an attribute, or the
// metrics' comparison figures
export enum SegmentSource {
  ATTRIBUTE = 'ATTRIBUTE',
  VARIANTS = 'VARIANTS'
}
